module.exports = __webpack_public_path__ + "static/img/SUB_01.971f78f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/SUB_01.png
// module id = 5KgV
// module chunks = 1